import { jsx as _jsx } from "react/jsx-runtime";
import ProfileContainer from "@components/profile-container";
import React from "react";
var Companies = function(param) {
    var guestData = param.guestData, tombstoneComponents = param.tombstoneComponents;
    return /*#__PURE__*/ _jsx(ProfileContainer, {
        guestData: guestData,
        tombstoneComponents: tombstoneComponents,
        type: "companies"
    });
};
export var __N_SSG = true;
export default Companies;
